import type { ContractConversionIndexData } from 'gql/graphql';

export enum ConversionCoefficientsKeys {
    kemm = 'kemm',
    keqp = 'keqp',
    kmtr = 'kmtr',
    knr = 'knr',
    kozp = 'kozp',
    kpir = 'kpir',
    ksp = 'ksp',
}

export const conversionCoefficientsKeys = Object.values(ConversionCoefficientsKeys);

export const getConversionIndicesCoefficientKey = (key: string, constructionTypeId: number) =>
    `${key}_${constructionTypeId}`;

export const getConstructionTypeCoefficientsKeys = (constructionTypeId: number) => [
    getConversionIndicesCoefficientKey(ConversionCoefficientsKeys.kemm, constructionTypeId),
    getConversionIndicesCoefficientKey(ConversionCoefficientsKeys.keqp, constructionTypeId),
    getConversionIndicesCoefficientKey(ConversionCoefficientsKeys.kmtr, constructionTypeId),
    getConversionIndicesCoefficientKey(ConversionCoefficientsKeys.knr, constructionTypeId),
    getConversionIndicesCoefficientKey(ConversionCoefficientsKeys.kozp, constructionTypeId),
    getConversionIndicesCoefficientKey(ConversionCoefficientsKeys.kpir, constructionTypeId),
    getConversionIndicesCoefficientKey(ConversionCoefficientsKeys.ksp, constructionTypeId),
];

export const conversionIndexInputToFlat = (item: any) =>
    Object.values(ConversionCoefficientsKeys).reduce((acc: any, key) => {
        acc[getConversionIndicesCoefficientKey(key, item.constructionType.id)] = item[key];

        return acc;
    }, {});

export const defaultToZero = (value: number | null | undefined) => value ?? 0;

export const nullsWithZeros = (item: ContractConversionIndexData): ContractConversionIndexData => ({
    ...item,
    kemm: defaultToZero(item.kemm),
    keqp: defaultToZero(item.keqp),
    kmtr: defaultToZero(item.kmtr),
    knr: defaultToZero(item.knr),
    kozp: defaultToZero(item.kozp),
    kpir: defaultToZero(item.kpir),
    ksp: defaultToZero(item.ksp),
});
